'use strict';

function infoLog() {
  var _console;

  return (_console = console).log.apply(_console, arguments);
}

export default infoLog;